import React, { type JSX } from 'react'
import {
  AddTagIcon,
  CampaignSubscribeIcon,
  CampaignUnsubscribeIcon,
  CommunityIcon,
  CommunityUnenrollIcon,
  CourseBundleEnrollIcon,
  CourseBundleUnenrollIcon,
  CourseIcon,
  CourseUnenrollIcon,
  SmsIcon,
  PipelineIcon,
  RemoveTagIcon,
  SendEmailIcon,
  GoogleSheetAddNewRowIcon,
} from '@systemeio/ui/icons'
import { ContactWorkflowStepActionEnum } from 'modules/contacts/contact-page/enums/contact-workflow-step-action-enum'

export const contactWorkflowStepIconClassName = 'h-[25px] w-[25px] fill-brand-primary'

export const getContactWorkflowStepActionIcon = (
  action: ContactWorkflowStepActionEnum,
): JSX.Element => {
  switch (action) {
    case ContactWorkflowStepActionEnum.AddTag:
      return <AddTagIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.RemoveTag:
      return <RemoveTagIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.EnrollInCourse:
      return <CourseIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.RevokeAccessToCourse:
      return <CourseUnenrollIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.RevokeAccessToCourseBundle:
      return <CourseBundleUnenrollIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.EnrollInCourseBundle:
      return <CourseBundleEnrollIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.SendEmail:
    case ContactWorkflowStepActionEnum.SendEmailToSpecificAddress:
    case ContactWorkflowStepActionEnum.SendWebhook:
      return <SendEmailIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.SubscribeToCampaign:
      return <CampaignSubscribeIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.UnsubscribeFromCampaign:
      return <CampaignUnsubscribeIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.GrantAccessToCommunity:
      return <CommunityIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.RevokeAccessToCommunity:
      return <CommunityUnenrollIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.AssignPipelineStage:
      return <PipelineIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.SendSms:
      return <SmsIcon className={contactWorkflowStepIconClassName} />
    case ContactWorkflowStepActionEnum.SendToGoogleSheets:
      return <GoogleSheetAddNewRowIcon className={contactWorkflowStepIconClassName} />
  }
}
